/**
 * Runtime guard for required environment variables.
 *
 * In dev: throws a blocking error so the developer sees it immediately.
 * In prod: logs a console.error and continues rendering — a missing env var
 * degrades chat/notifications (no WebSocket) but must never white-screen the
 * entire site.
 *
 * Vite inlines import.meta.env vars at build time, so a var missing from the
 * Amplify console is baked into the bundle as undefined. A hard throw at module
 * load would break the site for every user.
 */
const REQUIRED_ENV_VARS = [
  'VITE_APP_BACKEND_CHAT',
  'VITE_APP_WEBSOCKET',
  'VITE_APP_CDN_URL',
  'VITE_TELEMETRY_COLLECTOR_URL',
] as const;

const missing: string[] = [];

for (const key of REQUIRED_ENV_VARS) {
  if (!import.meta.env[key]) {
    missing.push(key);
  }
}

if (missing.length > 0) {
  const message =
    `Missing required environment variables: ${missing.join(', ')}. ` +
    `See .env.example for documentation. Set in .env.local (local dev) ` +
    `or Amplify console (deployed).`;

  if (import.meta.env.DEV) {
    // Hard fail in dev — the developer needs to fix this before testing.
    throw new Error(message);
  }

  // Prod: log loudly but let the app render. Chat and notifications will
  // degrade (no WebSocket / CDN assets) but the rest of the site works.
  console.error(message);
}

export {};
